angular
  .module("bot")

  .directive("botTyping", () => {
    return {
      restrict: "E",
      template: `<div ng-show="show" class="typing-indicator" ng-class="{'ticket-mode': ticketMode, show: show, 'with-menu': withMenu}"><span></span><span></span><span></span></div>`,
      replace: true,
      scope: {
        ticketMode: "=",
        show: "=",
        withMenu: "="
      }
    };
  });
